import { render, staticRenderFns } from "./AsyncWorldMap.vue?vue&type=template&id=5c6d27b9&"
import script from "./AsyncWorldMap.vue?vue&type=script&lang=js&"
export * from "./AsyncWorldMap.vue?vue&type=script&lang=js&"
import style0 from "./AsyncWorldMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AsyncWorldMap.vue"
export default component.exports